import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  .quantity__main-wrapper {\n    display: flex;\n    width: max-content;\n    align-content: center;\n    align-items: baseline;\n\n    border: 1px solid ", ";\n    padding: 10px 8px;\n\n    font-family: ", ";\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 100%;\n    letter-spacing: 0%;\n    color: ", ";\n\n    input,\n    select,\n    option {\n      font-family: ", ";\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 100%;\n      letter-spacing: 0%;\n      text-align: center;\n    }\n\n    label {\n      margin-right: 0.15rem;\n      cursor: pointer;\n      color: ", ";\n      font-size: 18px;\n    }\n\n    .input_wrapper {\n      display: flex;\n      width: max-content;\n      align-content: center;\n      align-items: baseline;\n\n      input[type='text'] {\n        max-width: 40px;\n        padding: 3px 2px 3px 2px;\n        border: 1px solid transparent;\n\n        &:focus {\n          background: ", ";\n          outline: none;\n        }\n\n        &:focus + .icon,\n        &:active + .icon {\n          display: none;\n        }\n      }\n\n      .icon {\n        width: 24px;\n        height: 24px;\n        background-image: url('data:image/svg+xml, %3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M20.0306%209.53062L12.5306%2017.0306C12.4609%2017.1003%2012.3782%2017.1557%2012.2871%2017.1934C12.1961%2017.2312%2012.0985%2017.2506%2011.9999%2017.2506C11.9014%2017.2506%2011.8038%2017.2312%2011.7127%2017.1934C11.6217%2017.1557%2011.539%2017.1003%2011.4693%2017.0306L3.9693%209.53062C3.82857%209.38988%203.74951%209.19901%203.74951%208.99999C3.74951%208.80097%203.82857%208.61009%203.9693%208.46936C4.11003%208.32863%204.30091%208.24957%204.49993%208.24957C4.69895%208.24957%204.88982%208.32863%205.03055%208.46936L11.9999%2015.4397L18.9693%208.46936C19.039%208.39968%2019.1217%208.34441%2019.2128%208.30669C19.3038%208.26898%2019.4014%208.24957%2019.4999%208.24957C19.5985%208.24957%2019.6961%208.26898%2019.7871%208.30669C19.8781%208.34441%2019.9609%208.39968%2020.0306%208.46936C20.1002%208.53905%2020.1555%208.62177%2020.1932%208.71282C20.2309%208.80386%2020.2503%208.90144%2020.2503%208.99999C20.2503%209.09854%2020.2309%209.19612%2020.1932%209.28716C20.1555%209.37821%2020.1002%209.46093%2020.0306%209.53062Z%22%20fill%3D%22%231871BD%22%2F%3E%0A%3C%2Fsvg%3E');\n        background-repeat: no-repeat;\n        background-position: 0px 4px;\n        background-size: 24px 24px;\n      }\n    }\n\n    select {\n      appearance: none;\n      border: 1px solid transparent;\n\n      background-image: url('data:image/svg+xml, %3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M20.0306%209.53062L12.5306%2017.0306C12.4609%2017.1003%2012.3782%2017.1557%2012.2871%2017.1934C12.1961%2017.2312%2012.0985%2017.2506%2011.9999%2017.2506C11.9014%2017.2506%2011.8038%2017.2312%2011.7127%2017.1934C11.6217%2017.1557%2011.539%2017.1003%2011.4693%2017.0306L3.9693%209.53062C3.82857%209.38988%203.74951%209.19901%203.74951%208.99999C3.74951%208.80097%203.82857%208.61009%203.9693%208.46936C4.11003%208.32863%204.30091%208.24957%204.49993%208.24957C4.69895%208.24957%204.88982%208.32863%205.03055%208.46936L11.9999%2015.4397L18.9693%208.46936C19.039%208.39968%2019.1217%208.34441%2019.2128%208.30669C19.3038%208.26898%2019.4014%208.24957%2019.4999%208.24957C19.5985%208.24957%2019.6961%208.26898%2019.7871%208.30669C19.8781%208.34441%2019.9609%208.39968%2020.0306%208.46936C20.1002%208.53905%2020.1555%208.62177%2020.1932%208.71282C20.2309%208.80386%2020.2503%208.90144%2020.2503%208.99999C20.2503%209.09854%2020.2309%209.19612%2020.1932%209.28716C20.1555%209.37821%2020.1002%209.46093%2020.0306%209.53062Z%22%20fill%3D%22%231871BD%22%2F%3E%0A%3C%2Fsvg%3E');\n      background-repeat: no-repeat;\n      padding: 5px 5px 5px 5px;\n      background-position: center right;\n      padding-right: calc(0.75em + 0.75rem);\n      background-size: 22px;\n\n      option {\n        text-align: center;\n      }\n    }\n  }\n\n  [data-type='select'] {\n    border: 1px solid transparent;\n  }\n\n  [data-type='input'] {\n    border: 1px solid ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { useEffect, useRef, useState } from 'react';
import hash from 'string-hash';
import { SERIF, CHARLES_BLUE, GRAY_200 } from '../utilities/constants';

var QuantityDropdown = function QuantityDropdown(props) {
  var _props$id = props.id,
      id = _props$id === void 0 ? 'quantityDropDown' : _props$id,
      _props$label = props.label,
      label = _props$label === void 0 ? 'Quantity' : _props$label,
      _props$labelName = props.labelName,
      labelName = _props$labelName === void 0 ? 'Quantity' : _props$labelName,
      propQuantity = props.quantity,
      _props$maxLength = props.maxLength,
      maxLength = _props$maxLength === void 0 ? 3 : _props$maxLength,
      _props$selectOptions = props.selectOptions,
      selectOptions = _props$selectOptions === void 0 ? {
    start: 1,
    total: 10
  } : _props$selectOptions;
  var selectOps = Array.from({
    length: selectOptions.total
  }, function (_, i) {
    return i + selectOptions.start;
  });
  var inputRef = useRef(null);
  var selectRef = useRef(null);

  var _useState = useState("".concat(selectOptions.start)),
      _useState2 = _slicedToArray(_useState, 2),
      selectValue = _useState2[0],
      setSelectValue = _useState2[1];

  var _useState3 = useState(propQuantity | 1),
      _useState4 = _slicedToArray(_useState3, 2),
      quantity = _useState4[0],
      setQuantity = _useState4[1];

  var _useState5 = useState(quantity < selectOps[selectOps.length - 1] ? 'select' : 'input'),
      _useState6 = _slicedToArray(_useState5, 2),
      type = _useState6[0],
      setType = _useState6[1];

  var ignoreKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Tab', 'Backspace'];

  var handleIconClick = function handleIconClick() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var handleLabelClick = function handleLabelClick() {
    if (selectRef && selectRef.current) {
      selectRef.current.focus();
    }

    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var handleQuantityChange = function handleQuantityChange(value) {
    // Allows user to delete the characters before typing in new ones.
    if (value) {
      setQuantity(+value);
      setSelectValue(+value > 10 ? 'other' : value);
    } else {
      setQuantity('');
    }
  };

  var handleSelectValueChange = function handleSelectValueChange(value) {
    setSelectValue(value);
    setQuantity(+value);

    if (type === 'input') {
      if (inputRef && inputRef.current) inputRef.current.focus();
    }

    if (parseInt(value) === selectOps[selectOps.length - 1]) {
      setType('input');
    }
  };

  var handleQuantityInputBlur = function handleQuantityInputBlur() {
    // If user erases value in field, return quantity to 1 on blur
    if (Number.isNaN(quantity)) handleQuantityChange('1');
    if (quantity < 1) handleQuantityChange('1');
  };

  var handleInputKeyDown = function handleInputKeyDown(event) {
    var key = event.key;

    if (isNaN(key) && !ignoreKeys.includes(key)) {
      event.preventDefault();
    }
  }; // If the quantity is passed down as props, use that value.


  useEffect(function () {
    if (props.quantity) handleQuantityChange(props.quantity.toString());
  }, []);
  useEffect(function () {
    props.handleQuantityChange(quantity);
  }, [quantity]);
  var key = id || "select-".concat(hash(label));

  var select_ops = function select_ops(options) {
    return options.map(function (val, i) {
      var attr = {
        value: val,
        key: "".concat(id, "_").concat(val, "__").concat(i)
      };
      return jsx("option", Object.assign({}, attr), val, options.length === i + 1 && "+");
    });
  };

  return jsx("div", {
    css: CS_QUANTITYDROPDOWN
  }, jsx("div", {
    className: "quantity__main-wrapper",
    "data-type": type,
    title: "".concat(labelName),
    "aria-label": "".concat(labelName)
  }, type === 'input' ? jsx("label", {
    htmlFor: "quantity_txtInput",
    onClick: handleIconClick
  }, labelName, ":") : jsx("label", {
    htmlFor: "quantityMenu",
    onClick: handleLabelClick
  }, labelName, ":"), type === 'input' && jsx("div", {
    className: "input_wrapper"
  }, jsx("input", {
    type: "text",
    name: "quantity_txtInput",
    value: quantity,
    "aria-label": "Quantity",
    maxLength: maxLength,
    tabIndex: 0,
    ref: inputRef,
    onChange: function onChange(event) {
      return handleQuantityChange(event.target.value);
    },
    onBlur: handleQuantityInputBlur,
    onKeyDown: handleInputKeyDown
  }), jsx("div", {
    className: "icon",
    onClick: handleIconClick
  })), type === 'select' && jsx("select", {
    id: key,
    name: "quantityMenu",
    value: selectValue,
    ref: selectRef,
    tabIndex: 0,
    onChange: function onChange(event) {
      return handleSelectValueChange(event.target.value);
    }
  }, select_ops(selectOps))));
};

var CS_QUANTITYDROPDOWN = css(_templateObject(), CHARLES_BLUE, SERIF, CHARLES_BLUE, SERIF, CHARLES_BLUE, GRAY_200, CHARLES_BLUE);
export default QuantityDropdown;